import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { useMediaQuery } from './hooks.js';
const UiContext = createContext(undefined);
// Create a provider for components to consume and subscribe to changes
export function UiStateProvider({ children }) {
    // Close the nav
    const wide = useMediaQuery('(min-width: 1280px)');
    const [state, setState] = useState({ isNavOpen: false });
    useEffect(() => {
        if (wide)
            setState(Object.assign(Object.assign({}, state), { isNavOpen: false }));
    }, [wide]);
    return _jsx(UiContext.Provider, { value: [state, setState], children: children });
}
export function useNavOpen() {
    var _a, _b;
    const [state, setState] = (_a = useContext(UiContext)) !== null && _a !== void 0 ? _a : [];
    const setOpen = (open) => {
        if (open === (state === null || state === void 0 ? void 0 : state.isNavOpen))
            return;
        setState === null || setState === void 0 ? void 0 : setState(Object.assign(Object.assign({}, state), { isNavOpen: open }));
    };
    return [(_b = state === null || state === void 0 ? void 0 : state.isNavOpen) !== null && _b !== void 0 ? _b : false, setOpen];
}
